import { cn } from '@/lib/utils';

import { Skeleton } from '@/components/ui/skeleton';

const TITLE_WIDTHS = ['w-2/5', 'w-1/3', 'w-1/2', 'w-1/4'];

interface ListSkeletonProps {
    rows?: number;
    className?: string;
}

export function ListSkeleton({ rows = 4, className }: ListSkeletonProps) {
    const rowIndexes = Array.from({ length: rows }, (_, index) => index);

    return (
        <div
            role="status"
            aria-busy="true"
            className={cn('divide-y divide-border', className)}
        >
            <span className="sr-only">Loading</span>
            {rowIndexes.map((row) => (
                <div key={row} className="flex items-center gap-3 px-5 py-3.5">
                    <Skeleton className="rounded-md size-6 shrink-0" />
                    <Skeleton
                        className={cn('h-4', TITLE_WIDTHS[row % TITLE_WIDTHS.length])}
                    />
                </div>
            ))}
        </div>
    );
}
